<!-- FAD MASIVO DESKTOP -->
<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
    <div class="create-account-container">

        <form class="form" *ngIf="!userData">
            <div class="mensaje">
                <p>Se você já é um usuário FAD:</p>
                <div class="edit-btn">
                    <button mat-raised-button [routerLink]="['/iniciar-sessao']" class="white-button">
                        CONECTE-SE
                    </button>
                </div>
                <p>Ou <a (click)="createAccount()">crie sua conta</a> com 3 assinaturas grátis por mês.</p>
            </div>
        </form>

        <div class="account-created" *ngIf="userData">
            <div class="item">
                <div class="info">
                    <p class="title">Nome do usuário </p>
                    <p>{{userData?.user}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Nome</p>
                    <p>{{userData?.name}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Primeiro sobrenome</p>
                    <p>{{userData?.lastName}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">E-mail</p>
                    <p>{{userData?.email}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>
        </div>
        <div class="disabled" *ngIf="!active"></div>
    </div>

</div>

<!-- FAD MASIVO RESPONSIVO -->
<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">

    <form class="form" *ngIf="!userData">
        <div class="mensaje">
            <p>Se você já é um usuário FAD:</p>
            <div class="edit-btn">
                <button mat-raised-button [routerLink]="['/iniciar-sessao']" class="blanco-button">
                    INICIAR SESSAO
                </button>
            </div>
            <p>Ou <a (click)="createAccount()">crie sua conta</a> com 3 assinaturas grátis por mês.</p>
        </div>
    </form>

    <div class="account-created" *ngIf="userData">
        <div class="item">
            <div class="info">
                <p class="title">Nome do usuário </p>
                <p>{{userData?.user}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Nome</p>
                <p>{{userData?.name}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Primeiro sobrenome</p>
                <p>{{userData?.lastName}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">E-mail</p>
                <p>{{userData?.email}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>
    </div>

    <div class="disabled" *ngIf="!active"></div>

</div>
